module.exports = __webpack_public_path__ + "img/case.3ab9dfb8.svg";